// extracted by mini-css-extract-plugin
export default {"antiScroll":"styles_antiScroll__ZiMPI"};